import { getTranslation } from "@mivo/i18n";
import type { LegalSection } from "@/domains/shared/constants/legalDocuments";
import { LEGAL_DOCUMENT_CHROME_TRANSLATIONS } from "@/domains/shared/constants/legalDocuments";

type LegalDocumentBodyProps = {
    sections: LegalSection[];
    version: string;
    effectiveDate: string;
};

export default function LegalDocumentBody({ sections, version, effectiveDate }: LegalDocumentBodyProps) {
    return (
        <div>
            <p className="text-sm text-muted-foreground/90 leading-relaxed">
                {getTranslation(LEGAL_DOCUMENT_CHROME_TRANSLATIONS.versionLabel)} {version} ·{" "}
                {getTranslation(LEGAL_DOCUMENT_CHROME_TRANSLATIONS.lastUpdatedLabel)}: {effectiveDate}
            </p>

            <section className="mt-6 space-y-8 text-sm leading-relaxed text-foreground">
                {sections.map((section) => (
                    <div key={section.title}>
                        <h2 className="mb-2 font-display font-semibold text-foreground">{section.title}</h2>
                        {section.paragraphs.map((paragraph) => (
                            <p key={paragraph.slice(0, 40)} className="mt-2">
                                {paragraph}
                            </p>
                        ))}
                    </div>
                ))}
            </section>
        </div>
    );
}

